<template>
    <span
        class="vf-badge vf-label-text"
        :class="classes"
        :aria-label="ariaLabel"
    >
        <span :aria-hidden="Boolean(ariaLabel).toString()">
            <slot />
        </span>
    </span>
</template>

<script>
import { PALETTES } from 'design-assets/constants/palettes.js';
import { VALID_PALETTES } from './constants.js';
import VueTypes from 'commons/util/vue-types.js';

export const PALETTE_CLASSES = {
    [PALETTES.ACCENT]: 'vf-badge--accent-color',
    [PALETTES.MENTION]: 'vf-badge--mention-color',
    [PALETTES.WARNING]: 'vf-badge--warning-color',
    [PALETTES.DANGER]: 'vf-badge--error-color',
    [PALETTES.DARK_PRIMARY]: 'vf-badge--dark-primary-color',
    [PALETTES.LIGHT_PRIMARY]: 'vf-badge--light-primary-color',
};

export default {
    props: {
        palette: VueTypes.oneOf(VALID_PALETTES).def(PALETTES.ACCENT),
        outline: VueTypes.bool.def(false),
        disabled: VueTypes.bool.def(false),
        ariaLabel: VueTypes.string,
    },

    computed: {
        classes() {
            return {
                [PALETTE_CLASSES[this.palette]]: true,
                'vf-badge--disabled': this.disabled,
                'vf-badge--outlined': this.outline,
            };
        },
    },
};
</script>

<style lang="scss" scoped>
@import '../../../css/variables/module';

@mixin outlined($color, $color-light) {
    &.vf-badge--outlined {
        @include var(color, $color);
        @include var(border-color, $color-light);

        background-color: transparent;
    }
}

.vf-badge {
    display: inline-block;
    min-width: auto;
    line-height: 1;
    white-space: nowrap;
    text-align: center;
    text-transform: uppercase;
    border: 1px solid transparent;

    &--accent-color {
        @include outlined('accent-color', 'accent-color-light');
        @include var(color, 'text-on-accent-color');
        @include var(background-color, 'accent-color');
    }

    &--mention-color {
        @include outlined('mention-color', 'mention-color-light');
        @include var(color, 'text-on-mention-color');
        @include var(background-color, 'mention-color');
    }

    &--warning-color {
        @include outlined('warning-color', 'warning-color-light');
        @include var(color, 'text-on-warning-color');
        @include var(background-color, 'warning-color');
    }

    &--error-color {
        @include outlined('error-color', 'error-color-light');
        @include var(color, 'text-on-error-color');
        @include var(background-color, 'error-color');
    }

    &--light-primary-color {
        @include outlined('primary-color-10', 'primary-color-30');
        @include var(color, 'primary-color-60');
        @include var(background-color, 'primary-color-10');
    }

    &--dark-primary-color {
        @include outlined('primary-color-60', 'primary-color-30');
        @include var(color, 'text-on-primary-color');
        @include var(background-color, 'primary-color-60');
    }

    &--disabled {
        @include outlined('primary-color-60', 'primary-color-30');
        @include light-text($default-palette);
        @include var(background-color, 'primary-color-10');
    }
}
</style>
